import {inject, Pipe, PipeTransform} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {RefundStatus} from '@gatewee/types/refund';

@Pipe({
  name: 'refundStatus',
  pure: false,
  standalone: false,
})
export class RefundStatusPipe implements PipeTransform {
  private readonly translate = inject(TranslateService);

  transform(value: RefundStatus | string | undefined): string {
    return (
      this.translate.instant(`enums.refundStatus.${value}`) ||
      this.translate.instant('common.unknown')
    );
  }
}
